module.exports = __webpack_public_path__ + "579f261bbc51bd69c3b7fb66009e588f.jpg";